import { FC, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";

import PurposeInputField from "./PurposeInputField";

// @ts-ignore
import rewardsIcon from "assets/images/journeys/purpose/rewards.svg";

// @ts-ignore
import consequencesIcon from "assets/images/journeys/purpose/consequences.svg";

// @ts-ignore
import obstaclesIcon from "assets/images/journeys/purpose/obstacles.svg";

// @ts-ignore
import solutionsIcon from "assets/images/journeys/purpose/solutions.svg";

// @ts-ignore
import vsIcon from "assets/images/journeys/purpose/vs-icon.svg";

import { DataType } from "components/InputAreaAI/components/Assistant/data";

import {
  Wrapper,
  Header,
  Title,
  HeaderDivider,
  Section,
  SectionTitle,
  Row,
  Col,
  Divider
} from "./styled";

interface IPurpose {
  data: any;
  onUpdate: (fields: { [key: string]: any }, areaId: string, goalId: string, callback?: () => void) => void;
}

const Purpose: FC<IPurpose> = ({ data, onUpdate }) => {
  const dispatch = useDispatch();

  // Create refs for each input field
  const rewardsRef = useRef(null);
  const consequencesRef = useRef(null);
  const obstaclesRef = useRef(null);
  const solutionsRef = useRef(null);
  
  // Handle changes to input fields
  const handleChange = useCallback((value: string, field: string, ai?: boolean) => {
    // If the change is from AI, update the value
    if (ai && data?.id) {
      onUpdate({ [field]: value }, data.id, data.goal?.id);
    }
  }, [data?.id, onUpdate]);
  
  // Handle saving changes
  const handleSave = useCallback((value: string, field: string) => {
    if (!data?.goal?.id)
      return;
    
    // Dispatch action to update the goal
    onUpdate({ [field]: value }, data.id, data.goal?.id);
  }, [data?.goal?.id, dispatch]);
  
  return (
    <Wrapper>
      <Header>
        <Title>Purpose</Title>
      </Header>
      
      <HeaderDivider />
      
      <Section>
        <SectionTitle>MOTIVATION</SectionTitle>
        <Row $color={data?.color}>
          <Col>
            <PurposeInputField
              icon={rewardsIcon}
              label="Rewards"
              placeholder="If I do..."
              value={data?.goal?.pleasure || ""}
              type={DataType.REWARD}
              goalData={{
                area: data?.name || "",
                category: data?.goal?.category_name || "",
                goal_name: data?.goal?.goal_name || "",
              }}
              onChange={handleChange}
              onSave={handleSave}
              name="pleasure"
              ref={rewardsRef}
              nextInputRef={consequencesRef}
            />
          </Col>
          
          <Divider>VS</Divider>
          
          <Col>
            <PurposeInputField
              icon={consequencesIcon}
              label="Consequences"
              placeholder="If I don't..."
              value={data?.goal?.pain || ""}
              type={DataType.CONSEQUENCE}
              goalData={{
                area: data?.name || "",
                category: data?.goal?.category_name || "",
                goal_name: data?.goal?.goal_name || "",
              }}
              onChange={handleChange}
              onSave={handleSave}
              name="pain"
              ref={consequencesRef}
              nextInputRef={obstaclesRef}
            />
          </Col>
        </Row>
      </Section>
      
      <Section>
        <SectionTitle>STRATEGY</SectionTitle>
        <Row $color={data?.color}>
          <Col>
            <PurposeInputField
              icon={obstaclesIcon}
              label="Obstacles"
              placeholder="What's stopping me?"
              value={data?.goal?.obstacles || ""}
              type={DataType.OBSTACLES}
              goalData={{
                area: data?.name || "",
                category: data?.goal?.category_name || "",
                goal_name: data?.goal?.goal_name || "",
              }}
              onChange={handleChange}
              onSave={handleSave}
              name="obstacles"
              ref={obstaclesRef}
              nextInputRef={solutionsRef}
            />
          </Col>
          
          <Divider><img src={vsIcon} alt="VS" /></Divider>
          
          <Col>
            <PurposeInputField
              icon={solutionsIcon}
              label="Solutions"
              placeholder="How I'll Do It..."
              value={data?.goal?.solutions || ""}
              type={DataType.SOLUTIONS}
              goalData={{
                area: data?.name || "",
                category: data?.goal?.category_name || "",
                goal_name: data?.goal?.goal_name || "",
              }}
              onChange={handleChange}
              onSave={handleSave}
              name="solutions"
              ref={solutionsRef}
            />
          </Col>
        </Row>
      </Section>
    </Wrapper>
  );
};

export default Purpose;